import {BaseClient} from './base';
import AWS from 'aws-sdk';
import Evidently, {JsonValue, VariableValue} from 'aws-sdk/clients/evidently';
import {getIdentity} from '@soluto-private/mx-analytics';
import {CognitoConfig, EvidentlyConfig} from '../types/config';
import {defaultCognitoConfig, defaultEvidentlyConfig} from '../defaultConfigs';

export class EvidentlyClient implements BaseClient {
    private client: AWS.Evidently;
    private evidentlyConfig: EvidentlyConfig;
    private cognitoConfig: CognitoConfig;

    public async configure(evidentlyConfig?: EvidentlyConfig, cognitoConfig?: CognitoConfig) {
        this.evidentlyConfig = evidentlyConfig ? evidentlyConfig : defaultEvidentlyConfig;
        this.cognitoConfig = cognitoConfig ? cognitoConfig : defaultCognitoConfig;
        const credentials = new AWS.CognitoIdentityCredentials(
            {
                IdentityPoolId: this.cognitoConfig.COGNITO_POOL_ID || '',
                RoleArn: this.cognitoConfig.COGNITO_ARN || '',
            },
            {region: this.cognitoConfig.COGNITO_REGION}
        );
        await credentials.getPromise();
        this.client = new Evidently({
            endpoint: this.evidentlyConfig.ENDPOINT,
            region: this.evidentlyConfig.REGION,
            credentials,
        });
    }

    private extractResult = <T>(response): T => {
        const valueKey = Object.keys(response.value)[0];
        return response.value[valueKey] as unknown as T;
    };

    public async getFlagValue<T>(key: string, defaultValue?: T, evaluationContext?): Promise<T> {
        const userBrowserId = getIdentity('UserBrowserId');

        if (!this.client) {
            await this.configure();
        }

        const evaluateFeatureRequest: Evidently.EvaluateFeatureRequest = {
            entityId: userBrowserId,
            feature: key,
            project: this.evidentlyConfig.PROJECT,
            evaluationContext: {
                hostname: window.location.hostname,
                ...evaluationContext,
            } as unknown as JsonValue,
        };

        try {
            const response = await this.client.evaluateFeature(evaluateFeatureRequest).promise();
            return this.extractResult(response);
        } catch (err) {
            return defaultValue;
        }
    }
}
